import Component from "../classes/Component";

export default function () {


    return new Component({
        name: 'pagination',

        requiredTargets: [],

        onInit() {
        },
        onDestroy() {
        },
    })

}